module.exports = __webpack_public_path__ + "img/hfdl-icon-2@2x.df6fe13d.png";